// Asset catalog (English).
window.PlummeI18n.register('en', {
  "supplierPay.correct": "Correct supplier settlement",
  "purchaseFlow.subtitle": "Purchases, supplier invoices and settlements",
  "purchaseFlow.type": "Type",
  "supplierPay.settlement": "Settlement",

  "asset.impairmentCancelled": "Cancelled impairment",
  "asset.impairmentCorrectionBlocked": "Select an active impairment with one attributable asset and enter a reason. Correct subsequent asset postings first. Sold and imported assets require review.",
  "asset.correctionEntriesRequired": "The correction requires attributable entries in the same open year, no later than the correction date.",
  "asset.alreadyCancelled": "This acquisition has already been cancelled.",
  "asset.cancelCurrentDate": "Purchase cancellation uses the current accounting reversal date.",
  "asset.cancelWholePurchase": "Select an unsold whole-purchase asset. Mixed purchases require a document-level correction.",
  "asset.cancelSameYear": "Document a correction in the same open acquisition year.",

  "asset.autoCancelBody": "Plumme reverses the whole purchase, VAT, linked payments and the asset\u2019s recorded depreciation and impairment. Original vouchers are preserved with traceable reversals.",
  "err.purchase.invoiceNumberRequired": "Enter the supplier invoice number before posting.",
  "err.supplierPayment.reverseUseFirst": "Reverse refunds and allocations before reversing this payment.",
  "supplierPay.description": "Payment of supplier invoice {number}",
  "supplierPay.total": "Invoice amount",
  "supplierPay.paid": "Paid / settled",
  "supplierPay.remaining": "Remaining",
  "supplierPay.available": "Credit available with supplier",
  "supplierPay.register": "Register payment",
  "supplierPay.link": "Link existing posting",
  "supplierPay.history": "Payment history",
  "supplierPay.selectInvoice": "Invoice to pay",
  "supplierPay.noInvoice": "No invoice selected",
  "supplierPay.overpayment": "The excess of {amount} will remain as credit with this supplier.",
  "supplierPay.open": "Open",
  "supplierPay.openTotal": "Unpaid invoices",

  'err.asset.reverseSaleBeforeAcquisition': 'Reverse the sale before changing the acquisition.',
  'asset.tabDrafts': 'Drafts ({n})',
  'asset.bookValueAtSale': 'Carrying value on sale date',
  'asset.taxDepreciation': 'Tax depreciation',
  'asset.bookTaxExplanation': 'The carrying value follows the asset depreciation plan. Tax value is calculated separately for its tax group. Tax figures cover the whole group when it contains several assets.',
  'asset.automationActivate': 'Activate and post',
  'asset.automationCatchUp': 'Review and post outstanding depreciation',
  'asset.automationPause': 'Pause automation',
  'asset.automationConfirmEnable': 'Confirm and post',
  'asset.automationConfirmAmount': 'Approve the depreciation plans and post {amount} for completed months through {date}. New completed months will then be posted automatically.',
  'asset.automationPauseExplanation': 'Pause future automatic posting. Already posted depreciation is preserved. Depreciation remains due; outstanding amounts still need to be posted.',
  'asset.automationEnabledSaved': 'Automation approved and completed months posted.',
  'asset.automationPausedSaved': 'Automation paused. Posted depreciation is preserved.',
  'asset.automationSaveFailed': 'The change could not be confirmed. Check its status before trying again.',
  'asset.automationPostingNotConfirmed': 'Posting is not confirmed. Check outstanding amounts and vouchers. Enabled automation alone does not confirm that depreciation was posted.',
  'asset.automationBasisChanged': 'The asset basis changed. Close this dialog and review the amounts again.',
  'asset.automationRequestUncertain': 'The server did not respond in time. Posting may have completed. Refresh the accounts and check the vouchers before trying again.',
  'asset.automationStatusAwaiting': 'Automation is enabled. No depreciation has been posted yet.',
  'asset.postingReviewRequired': 'Reconciliation required',
  'asset.projectedYearEndValue': 'Projected year-end value (plan)',
  'asset.usefulLifeSuggestionHelp': 'Useful life is an editable suggestion based on the group. Adjust it to expected use; this is not a tax rule.',
  'asset.advancedOptions': 'Advanced',
  'asset.advancedOptionsHelp': 'Adjust useful life, residual value or additional impairment when needed. Default values are already filled in.',
  'asset.editAdjustments': 'Adjust',
  'asset.hideAdjustments': 'Hide',
  'asset.automaticPlanSummary': 'Useful life: {years} years. Residual value: {residual}.',
  'asset.noExtraImpairmentDefault': 'No additional impairment by default.',
  'asset.optionalDocumentation': 'Documentation / explanation (optional)',

  'asset.title': 'Fixed assets',
  'asset.subtitle': 'Equipment and values the business owns over time',
  'asset.new': 'New asset',
  'asset.info': 'Info',
  'asset.accounting': 'Accounting',
  'asset.moreActions': 'More actions',
  'asset.automationStatusTitle': 'Automatic monthly posting',
  'asset.automationStatusActive': 'Active. Last posted through {date}.',
  'asset.automationStatusDefault': 'On by default. New assets are posted automatically each month after registration.',
  'asset.taxAutomaticTitle': 'Tax depreciation is calculated automatically',
  'asset.taxAutomaticHelp': 'Plumme applies the ordinary tax rules and proposes the amounts for {year}. You normally do not need to do anything here.',
  'asset.taxAutomaticDepreciation': 'Calculated depreciation',
  'asset.taxAutomaticIncome': 'Calculated income recognition',
  'asset.taxAutomaticDeduction': 'Calculated loss deduction',
  'asset.taxAdvancedChoices': 'Advanced choices',
  'asset.taxAdvancedHelp': 'Use this only to deviate from Plumme’s proposal or to register an opening gain/loss balance when changing systems.',
  'asset.changeTaxElection': 'Change tax election',
  'asset.taxElectionCurrentDefault': 'Plumme’s automatic proposal for the selected balance is {amount}.',
  'asset.taxElectionOverrideRequired': 'Enter an amount that should differ from the automatic proposal.',
  'asset.taxElectionReasonRequired': 'Explain why you are overriding the automatic proposal.',
  'asset.automationStatusOff': 'Off. Enable once to post completed months automatically.',
  'asset.automationStatusReview': 'Paused. Review the plans and approve automation again.',
  'asset.automationApprovalNote': 'Approved automatic monthly posting of accounting depreciation.',
  'asset.automationApprovalFailed': 'The asset was registered, but automatic monthly posting could not be enabled. Review the status on the Assets page.',
  'asset.autoPostingActive': 'Automatic monthly posting is the default',
  'asset.monthlyDepreciationPreview': 'Accounting depreciation will be approximately {amount} per month and will be posted automatically after registration.',
  'asset.monthlyDepreciationPreviewOff': 'Automatic monthly posting is disabled under Settings – Accounting.',
  'asset.manageInSettings': 'Manage in settings',
  'asset.special.financing': 'Loans and financing',
  'asset.special.tradeIn': 'Trade-ins',
  'asset.special.partialSale': 'Partial disposals',
  'asset.special.property': 'Property',
  'asset.specialCasesHelp': 'Practical guidance for situations that require separate documentation or allocation.',
  'asset.automationStopNote': 'Automatic monthly posting stopped by the user.',
  'asset.unpostedDepreciation': 'Remaining to post: {amount} through {date}.',
  'asset.importedHistory': 'Imported history',
  'asset.importedHistoryHelp': 'Historical fixed asset imported from another accounting system. Values and depreciation are shown from the import trail and are not posted again in Plumme.',
  'asset.edit': 'Edit asset',
  'asset.registerSold': 'Register as sold',
  'asset.moreOptions': 'More options',
  'asset.reclassifyPurchase': 'Convert to regular purchase',
  'asset.reclassifyTitle': 'Convert to regular purchase',
  'err.asset.reverseReclassificationBeforeAcquisition': 'Reverse the asset reclassification before annulling the purchase voucher.',
  "asset.acquisitionLockedTitle": "Why are these actions locked?",
  "asset.acquisitionLockedSold": "The asset is sold. Reverse the sale before correcting the purchase.",
  "asset.acquisitionLockedReview": "Reconcile the postings before correcting the purchase.",
  "asset.acquisitionLockedDepreciation": "Plumme calculates and records traceable reversals for the correction you select. Convert to purchase preserves the purchase and VAT. Annul or mistakenly registered reverses the purchase and linked depreciation and impairment. Locked periods and reconciled payments must be resolved first.",
  "asset.correctCapitalization": "Correct mistaken capitalization",
  "asset.correctCapitalizationBody": "Use this only when the purchase is valid but should have been expensed. Depreciation is reversed and acquisition cost transferred to the selected expense account in one save. Original vouchers, VAT and payments are retained. Choose a date after the last depreciation in the same open year. Group depreciation and impairment require separate review.",
  'asset.reclassifyBody': 'Use this when the purchase should not have been registered as an asset. The original voucher is preserved. A separate correction voucher transfers the acquisition cost to the selected expense account on your chosen date.',
  'asset.expenseAccount': 'Expense account',
  'asset.correctionReason': 'Reason',
  'asset.correctionReasonPh': 'E.g. below the threshold / wrong classification',
  'asset.reclassifiedToast': 'The purchase was converted to a regular purchase.',
  'asset.reclassifyError': 'Could not convert the asset to a regular purchase.',
  'asset.annulPurchase': 'Annul purchase voucher',
  'asset.annulTitle': 'Annul purchase voucher',
  'asset.annulBody': 'Use this when the whole purchase voucher is wrong or duplicated. The voucher is not deleted from history, but the posting is removed from reports and the trial balance.',
  'asset.annulLocksTitle': 'May be locked by VAT, bank or year-end',
  'asset.annulLocksBody': 'If the period has been submitted, bank reconciled or year-end closed, it must be reopened or corrected before the voucher can be annulled.',
  'asset.annulReasonPh': 'E.g. duplicate voucher / wrong upload',
  'asset.annulledToast': 'The purchase voucher was annulled.',
  'asset.annulError': 'Could not annul the purchase voucher.',
  'asset.markMistaken': 'Mark asset as registered by mistake',
  'asset.saleDate': 'Sale date',
  'asset.bookValueShort': 'Book value',
  'asset.saleAmountExVat': 'Sale amount excl. VAT',
  'asset.vat': 'VAT',
  'asset.howRegisterSale': 'How do you want to register the sale?',
  'asset.continueTitle': 'Continue?',
  'asset.continue': 'Continue',
  'asset.undoDeleteTitle': 'Undo deletion?',
  'asset.undoDelete': 'Undo deletion',
  'asset.undoSaleTitle': 'Undo sale?',
  'asset.undoSale': 'Undo sale',
  'asset.saveDraft': 'Save draft',
  'asset.name': 'Asset name',
  'asset.namePh': 'E.g. MacBook Pro 16"',
  'asset.depreciationNote': 'This purchase is registered as a fixed asset and depreciated at year-end.',
  'asset.supplierPurchase': 'Supplier purchase',
  'asset.supplier': 'Supplier',
  'asset.invoiceNumber': 'Invoice number',
  'asset.invoiceNumberPh': 'E.g. 100245',
  'asset.lines': 'Lines',
  'asset.linePh': 'E.g. machine, PC or tools',
  'asset.account': 'Fixed asset account',
  'asset.accountDepreciationHint': 'Depreciated by up to {rate}% per year at year-end closing.',
  'asset.vatRate': 'VAT rate',
  'asset.addLine': 'Add line',
  'asset.paidBy': 'Paid by',
  'asset.payOperating': 'Operating account - 1920',
  'asset.payCash': 'Cash - 1900',
  'asset.payPrivate': 'Private - 2060',
  'asset.payLoan': 'Paid by taking a loan - 2250',
  'asset.splitPayment': 'Split the payment',
  'asset.partPayments': 'Instalments',
  'asset.fullPayment': 'Full payment',
  'asset.addPartPayment': 'Add instalment',
  'asset.uploadFile': 'Upload file',
  'asset.dropFiles': 'Drag and drop files here, or choose from your computer.',
  'asset.removeAttachment': 'Remove attachment',
  'asset.sold': 'Sold',
  'asset.depreciated': 'Depreciated',
  'asset.active': 'Active',
  'asset.viewsTitle': 'Views',
  'asset.viewsHelp': 'Filter the list: "Active" are assets with a remaining book value that are still being depreciated, "Depreciated" are written down to 0, "Sold" have been disposed of, and "All" shows everything.',
  'asset.noneInView': 'No assets in this view yet',
  'asset.fromPurchase': 'Register from a purchase',
  'asset.group': 'Group',
  'asset.groupHelp': 'The balance group decides the depreciation rate — how large a share can be depreciated for tax each year. For example group C (vans) and group D (machinery, fixtures) have different rates set by Skatteetaten.',
  'asset.depreciatedHelp': 'The amount expensed so far — that is, how much of the cost price has already been depreciated over the years. Cost price minus depreciated gives the book value.',
  'asset.bookValue': 'Book value',
  'asset.bookValueHelp': 'The remaining value of the asset in the accounts now — cost price minus what has been depreciated. This is the amount left to depreciate over coming years.',
  'asset.declining': 'Declining-balance depreciation and forms',
  'asset.decliningHelp': 'Declining-balance is the most common depreciation method: each year a fixed percentage of the remaining balance is depreciated per group. The table shows the basis per balance group. RF-1084 and RF-1217 are Skatteetaten forms for depreciation and temporary differences — Plumme fills them in from the figures here.',
  'asset.opening': 'Opening',
  'asset.additions': 'Additions',
  'asset.disposals': 'Disposals',
  'asset.movements': 'Movements',
  'asset.depreciation': 'Depreciation',
  'asset.closing': 'Closing balance',
  'asset.groupDFallback': 'Balance group D – passenger cars, machinery and fixtures',
  'asset.attachmentFallback': 'Attachment',
  'asset.pageTitleHelp': 'Fixed assets are larger things the business owns and uses over several years — a PC, a vehicle, machinery, fixtures. They are not expensed all at once, but depreciated: the cost is spread a little each year over the useful life. Here Plumme keeps track of depreciation and form values for you.',
  'asset.pageAddHelp': 'Register a new asset when a fixed asset has a cost price of at least NOK 30,000 and an expected useful life of at least three years. The threshold does not apply to the invoice total alone.',
  'asset.emptyText': 'Fixed assets are things the business owns and uses over several years — like a PC, a vehicle or tools. They are depreciated a little each year. Register an asset from a purchase, and we will keep track of depreciation and form values for you.',
  'asset.tabActive': 'Active ({n})',
  'asset.tabDepreciated': 'Depreciated ({n})',
  'asset.tabSold': 'Sold ({n})',
  'asset.tabAll': 'All ({n})',
  'asset.colAsset': 'Asset',
  'asset.soldOnLabel': 'sold {date}',
  'asset.acquiredInline': 'Acquired {date}',
  'asset.groupRateInline': 'Group {group} · {rate} %',
  'asset.colAcquired': 'Acquired',
  'asset.colCost': 'Cost price',
  'asset.costInline': 'Cost price {amount}',
  'asset.colStatus': 'Status',
  'asset.decliningDescription': 'Basis for declining-balance depreciation per group. RF-1084 / RF-1217 are shown as form references for Norwegian tax logic.',
  'asset.depreciationInline': 'Depreciation −{amount}',
  'asset.atYearEnd': 'At the end of {year}',
  'asset.accountingValue': 'Accounting value',
  'asset.taxValue': 'Tax value',
  'asset.temporaryDifference': 'Temporary difference',
  'asset.noCustomer': 'No customer',
  'asset.fallbackNoun': 'asset',
  'asset.saleLineDescription': 'Sale of {name}',
  'asset.deletedStatus': 'Deleted',
  'asset.updateFailed': 'Could not update the asset.',
  'asset.transitionSaved': 'Transition values and assessment saved.',
  'asset.transitionSaveFailed': 'Could not save the transition values.',
  'asset.soldPendingOther': "Complete Other sale to register the asset as sold",
  'asset.soldPendingInvoice': "Create the invoice to register the asset as sold",
  'asset.registeredSold': 'Asset registered as sold',
  'asset.detailTitle': 'Asset: {name}',
  'asset.tabInfo': 'Information',
  'asset.tabDepreciationChanges': 'Depreciation / changes',
  'asset.tabForms': 'Forms',
  'asset.purchaseDate': 'Purchase date',
  'asset.purchasePrice': 'Purchase price',
  'asset.assetAccountLabel': 'Asset account',
  'asset.missingValue': 'Missing',
  'asset.usefulLifeLabel': 'Useful life',
  'asset.yearsCount': '{n} yrs',
  'asset.taxDepreciationRateLabel': 'Tax depreciation rate',
  'asset.impairmentAssessmentYear': 'Impairment assessment {year}',
  'asset.noIndicators': 'No indicators',
  'asset.impairedAmount': 'Written down {amount}',
  'asset.transitionHeading': 'Transition to Plumme',
  'asset.transitionBody': 'Historical posted values are kept. Register a separate opening tax value and a plan for continued year-end closing.',
  'asset.registerTransitionValues': 'Register transition values',
  'asset.colYear': 'Year',
  'asset.colType': 'Type',
  'asset.colDescription': 'Description',
  'asset.colAccountingChange': 'Accounting change',
  'asset.colNewValue': 'New value',
  'asset.sellTitle': 'Register asset as sold: {name}',
  'asset.sellNoInvoice': 'Register sale without invoice',
  'asset.createInvoiceBtn': 'Create invoice',
  'asset.markSoldBtn': 'Mark as sold',
  'asset.gainOnSale': 'Gain on sale',
  'asset.lossOnSale': 'Loss on sale',
  'asset.sellMethodMarkDesc': 'Use this when the sale income has already been posted.',
  'asset.sellMethodOtherDesc': 'Opens Other sale with the asset pre-filled.',
  'asset.sellMethodInvoiceDesc': 'Opens a new invoice draft with the asset as a line.',
  'asset.sellHelperPrefix': 'The sale reduces the depreciation balance in group {group}.',
  'asset.sellHelperMarkSuffix': 'Choose this only when the income has already been posted.',
  'asset.sellHelperOtherSuffix': 'We will take you further to post the actual sale income.',
  'asset.continueDeleteBody': 'Only use this if the asset was registered by mistake and should not be depreciated. Completed year-end/depreciation postings should be reversed before the asset is marked as deleted.',
  'asset.markedDeleted': 'Asset marked as deleted',
  'asset.restoreDeleteBody': 'This makes the asset active again and includes it in the balance group, tax value and depreciation basis. If you have run year-end closing or posted depreciation while the asset was deleted, these should be checked and possibly reversed before you continue.',
  'asset.deleteUndone': 'Deletion undone',
  'asset.restoreSaleBody': 'Plumme reactivates the asset using traceable reversing entries. Choose below whether a linked sale document is also reversed or retained. Original vouchers are preserved and locked periods must be reopened before postings can change.',
  'asset.saleUndone': 'Sale undone',
  'asset.transitionTitle': 'Transition values: {name}',
  'asset.saveAssessment': 'Save assessment',
  'asset.savingEllipsis': 'Saving…',
  'asset.planStartLabel': 'Plan start in Plumme',
  'asset.remainingUsefulLifeYearsLabel': 'Remaining useful life (years)',
  'asset.taxOpeningValueYear': 'Opening tax value {year}',
  'asset.impairmentToBeRecordedShort': 'Impairment to be recorded',
  'asset.impairmentAmountLabel': 'Impairment amount',
  'asset.documentationLabel': 'Documentation / justification',
  'asset.importedHistoryUnchanged': 'Imported history does not change. The plan starts with the book value at the start of the year and is kept separate from the tax value.',
  'asset.nameRequired': 'The fixed asset name must be filled in.',
  'asset.amountMustBePositive': 'The amount must be greater than 0.',
  'asset.planFieldsInvalid': 'Fill in a valid ready-for-use date, useful life and residual value.',
  'asset.assessImpairmentRequired': 'Assess signs of impairment for {year}.',
  'asset.impairmentAmountRequired': 'Enter the impairment amount.',
  'asset.draftContentRequired': 'Add a name, line or attachment before saving the draft.',
  'asset.updated': 'Asset updated',
  'asset.registeredDepreciating': 'Asset registered - depreciated at year-end',
  'asset.saveFailed': 'Could not save the asset.',
  'asset.attachmentAdded': 'Attachment added.',
  'asset.savingDots': 'Saving...',
  'asset.registerAssetBtn': 'Register asset',
  'asset.bookDepreciationPanelTitle': 'Accounting depreciation plan',
  'asset.bookDepreciationPanelDesc': 'The plan controls the book value. The balance group below is used for tax purposes only.',
  'asset.usefulLifeYearsFieldLabel': 'Useful life (years)',
  'asset.noImpairmentIndicatorsOption': 'No indicators of impairment',
  'asset.impairmentToBeRecordedOption': 'Impairment to be recorded',
  'asset.documentationPlaceholder': 'Brief justification or reference to documentation',
  'asset.supplierPurchaseHelp': 'Link the asset to a supplier and invoice number when the purchase comes from a supplier invoice.',
  'asset.noDescriptionFallback': 'No description',
  'asset.amountModeGross': 'incl. VAT',
  'asset.amountModeNet': 'excl. VAT',
  'asset.hideVoucher': 'Hide voucher',
  'asset.showVoucher': 'Show voucher',
  'asset.reclassAcct6540': 'Fixtures',
  'asset.reclassAcct7700': 'Other expense',
  'asset.missingFileLink': 'Missing file link',
  'asset.cannotPreviewInBrowser': 'Cannot be previewed in the browser.',
  'asset.automaticPostingExplanation': 'Depreciation is posted automatically for each completed month. Plumme catches up on missed months without any action from you.',
  'asset.automaticPostingNeedsReview': 'Automatic depreciation needs attention. Check the asset plan or contact support. Plumme retries after the issue is corrected.',
  'asset.automaticScopeUnsupported': 'Automatic depreciation is currently available only for supported Norwegian accounting setups.',
  'asset.automaticCorrectionRequired': 'Complete the depreciation plan correction after the reversal. Automatic posting then continues.',
  'asset.automaticPostingThrough': 'Last depreciation posted: {date}.',
  'asset.automaticPostingPending': '{amount} remains through {date}. Plumme follows up automatically.',
});

window.PlummeI18n.register('en', {
  "err.nativeValidation.fixedAssetAcquisitionRegistration.1": "Choose one existing acquisition to register.",
  "err.nativeValidation.fixedAssetAcquisitionRegistration.2": "The acquisition is already registered as a fixed asset.",
  "err.nativeValidation.fixedAssetAcquisitionRegistration.3": "The registration date must match the source acquisition.",
});

window.PlummeI18n.register("en", {
  "purchaseFlow.overview": "Purchases",
  "purchaseFlow.search": "Search purchases",
  "purchaseFlow.status": "Status",
  "purchaseFlow.all": "All",
  "purchaseFlow.empty": "No purchases found.",
  "purchaseFlow.creditNumber": "Credit note number",
  "purchaseFlow.creditNumberRequired": "Enter the supplier credit note number.",
  "purchaseFlow.documents": "Attachments",
  "purchaseFlow.original": "Original invoice",
  "purchaseFlow.reverse": "Reverse payment",
  "purchaseFlow.reverseExplanation": "The entire payment is reversed, including allocations to other invoices. The history is retained.",
  "purchaseFlow.reason": "Reason",
  "purchaseFlow.more": "More actions"
});

window.PlummeI18n.register("en", {"purchaseFlow.paymentTotal": "Full payment: {amount}"});

window.PlummeI18n.register("en", {
  "err.supplierPayment.selectionRequired": "Missing invoice selection for supplier payment.",
  "err.supplierCredit.numberRequired": "Enter the supplier credit note number.",
  "err.supplierCredit.conflict": "Credit note request conflicts with an existing document.",
  "err.supplierCredit.duplicate": "Supplier credit note number is already registered."
});

window.PlummeI18n.register("en", {"purchaseFlow.purchase": "Purchase", "purchaseFlow.net": "Net", "purchaseFlow.vat": "VAT"});

window.PlummeI18n.register("en", {"asset.rename": "Rename asset"});



window.PlummeI18n.register("en", {"asset.cancelDates": "The purchase dated {purchase} and its linked entries are reversed on {date}. Original vouchers and dates are retained.", "err.asset.cancelDetailsRequired": "Document the reason and use a date on or after acquisition.", "err.asset.laterChangesRequired": "Reconcile later asset changes or unattributed depreciation before recording this sale."});
